/* eslint-disable no-eval */
import ValidateGlobal from './../../ValidateGlobal.js'
import ServiceGlobal from './../../InputsServiceGlobal.js'
import NumberUtilsLib from 'utils/NumberUtils'
import * as mathjs from 'mathjs'

export default {
  mixins: [ValidateGlobal, ServiceGlobal],
  props: {
    config: {
      type: Object
    },
    modelProps: {
      type: [String, Object, Number]
    },
    rootModel: {
      type: Object
    },
    parent: {
      type: Object
    }
  },
  model: {
    prop: 'modelProps',
    event: 'input'
  },
  data () {
    return {
      value: this.modelProps,
      valueShow: this.modelProps,
      math: mathjs,
      NumberUtils: NumberUtilsLib
    }
  },
  created () {
    this.$on('notifySubriber', this.listenConsumer)
    this.value = eval(this.config.func)
    if (this.config.afterCompute) eval(this.config.afterCompute)
  },
  computed: {
    validationRules () {
      return this.expressionResolver(this.config.validation)
    }
  },
  watch: {
    value: {
      handler: function (newValue) {
        if (!this.config.showOnly) {
          this.$emit('input', newValue)
        }
      },
      deep: true
    },
    'parent.modelProps': {
      // eslint-disable-next-line no-unused-vars
      handler: function (newValue, oldValue) {
        this.value = eval(this.config.func)
        if (this.config.afterCompute) eval(this.config.afterCompute)
      },
      deep: true
    }
  },
  methods: {
    validate () {},
    listenConsumer() {
      this.value = eval(this.config.func)
      if (this.config.afterCompute) eval(this.config.afterCompute)
    }
  }
}
